import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PixStatusEnum } from '../../pix-results.component';
import { NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'update-pix-status',
    templateUrl: './update-pix-status.component.html',
    styleUrls: ['./update-pix-status.component.scss'],
})
export class UpdatePixStatusComponent implements OnInit {
    ngOnInit(): void {}
    description: string = '';
    newPixStatusSelected: number = 0;
    PixStatusEnum = PixStatusEnum;

    constructor(
        private notification: NotificationsService,
        public dialogRef: MatDialogRef<UpdatePixStatusComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.description = data.description;
        this.newPixStatusSelected = data.newPixStatusSelected;
    }
    onStatusPixChanged(evt: any) {
        this.description = '';
    }
    confirm() {
        if (this.newPixStatusSelected == PixStatusEnum.Error && this.description == '') {
            this.notification.warn('O uso da descrição do erro é obrigatório');
            return;
        }

        this.dialogRef.close({
            description: this.description,
            newPixStatusSelected: this.newPixStatusSelected,
        });
    }
}
